<template>
	<div class="chat-container w-100 position-relative bg-white h-100">
    <div id="top-section"></div>
    <div class="my-5 text-center" v-if="is_load">
      <loader />
    </div>
    <template v-else>
      <div class="my-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
      	<div class="bg-white">
      		<!-- NAVBAR -->
      		<div class="px-4">
	          <div class="row no-gutters py-4 position-relative">
	          	<div class="col-1">
	          		<router-link :to="'/'+getMerchant.code" >
                  <img src="../../../../assets/img/icon/back.png" class="mt-1" width="20">
                </router-link>
	          	</div>
	          	<div class="col-9">
	          		<div class="ml-2-back d-inline-block align-middle" v-if="merchant_area != ''">
	                <!-- <p class="body-2-2 font-regular text-12 mb-0" style="line-height:1 !important">{{`Hi, ${getCurrentUser.first_name}`}}</p> -->
	                <p class="body-2-2 font-regular text-12 mb-0">{{$t("hotel.concierge.fitur.experience.current-location")}}:</p>
	              	<p class="mb-0 body-2-4">{{merchant_area}}</p>
	              </div>
	          	</div>
	          	<div class="col-2 text-right">
	              <div class="language language-custom bg-green" style="top:0 !important" @click="toggleLanguage(true)">
	                <p class="mb-0 body-2-2 font-extrabold text-white text-uppercase">{{getCurrentLanguage}}</p>
	              </div>
	            </div>
	          </div>
      		</div>

          <!-- SEARCH INPUT -->
	        <div class="container px-4">
	        	<p class="body-2-2 text-24 font-extrabold mb-0" style="line-height:1 !important;letter-spacing:0px !important">{{data.tagline}}</p>
	          <p class="mt-1 mb-2 body-2">{{data.sub_tagline}}</p>
	        </div>
          <div class="bg-white border-bottom-5-light pb-4 mb-4">
	          <div class="px-4 w-100 py-3 bg-white mb-2 position-relative">
	            <input type="text" placeholder="Search activities" ref="search" class="w-100 body-2-1 ls-0-1 bg-light search-custom radius-12" @input="keywordType" v-model="keyword" />
	            <img v-if="keyword != ''" @click="clearSearch()" src="../../../../assets/img/icon/close.png" height="12" class="position-absolute cursor-pointer" style="right:41px;top:33px;">
		        </div>

		        <div class="w-100 pl-4 bg-white">
			        <!-- <p class="mb-0 body-1-1 text-16 mb-2">Categories</p> -->
		        	<div class="position-relative">
              	<div class="div-wrapper mx-auto d-inline-block m-width-100" id="category" style="width: 100%">
              		<flickity ref="flickity" class="flickity-category" :options="slider_option.merchant" style="height: auto;"> 
				            <div class="carousel-cell-categoryz" 
				              v-for="cat in category.list" @click="goToScroll(cat)" style="width: max-content;">
				              <div class="d-inline-block align-top px-2 text-center cat-wrapper" @click="goToScroll(cat)">
						        		<div class="icon-wrapper-circle mb-2 d-table mx-auto cursor-pointer" :class="{'border-green':cat.id == category.selected.id}">
					          			<img :src="cat.image_url" width="25" style="margin:10px">
					          		</div>
					          		<p class="mb-0 body-3-1 cursor-pointer" :class="{'font-bold text-green':cat.id == category.selected.id}">{{cat.name}}</p>
						        	</div>
				            </div>
				          </flickity>
					      </div>
			        </div>
			      </div>
          </div>

          <div class="px-4 pt-2">
		        <!-- Top Destination -->
	          <!-- <div v-if="false" class="w-100 pb-2">
		        	<p class="mb-0 body-1-1 text-16 mb-2">{{$t("hotel.concierge.fitur.experience.recommended-activities")}}</p>
		        	<div class="position-relative">
	              <div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: -17px;top: 85px" @click="xScroll('left', 'nearby')">
	                <img src="../../../../assets/img/icon/green-arrow-left.png" width="18" class="next-button position-relative" style="left: 0;z-index: 9">
	              </div>
	              <div class="div-wrapper mx-auto d-inline-block m-width-100" id="nearby" style="width: 100%">
	                <div class="" style="width: max-content">
	                  <template v-for="(data,index) in top_data">
	                    <ThingsToDoItem :data="data"></ThingsToDoItem>
	                  </template>
	                </div>
	              </div>
	              <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: -20px;top: 85px;" @click="xScroll('right', 'nearby')">
	                <img src="../../../../assets/img/icon/green-arrow-right.png" width="18" class="next-button position-relative" style="right: 12px;z-index: 9">
	              </div>
	            </div>
		        </div> -->

						<ClaimingReward wrapper_class="mb-4"></ClaimingReward>

		        <!-- Per Category -->
		        <span id="merchant" class="position-absolute" style="top: 250px"></span>
		        <template v-if="category.selected.id == 'all' && keyword == ''">
		          <div class="w-100 pb-2" v-for="cat_data in data.category_list" :id="cat_data.id">
			        	<p class="mb-0 body-1-1 text-16 mb-2">{{cat_data.name}}</p>
			        	<div class="row slim-grid-row mb-3">
			        		<div class="col-6 mb-3" v-for="(merchant,index) in cat_data.merchant_list">
		              	<ThingsToDoItem :data="merchant" width="100%"></ThingsToDoItem>
			        		</div>
			        	</div>
		        		<div v-if="cat_data.merchant_length > 6" @click="loadMoreData(cat_data)" class="text-center w-100" >
	                <p class="body-2 px-3 mx-auto d-table mb-0 py-1 border_1 cursor-pointer text-12 rounded-3 font-bold delay bg-green text-white border-green">{{$t("hotel.concierge.fitur.load-more")}}</p>
	              </div>
			        </div>
			      </template>
			      <template v-else>
			      	<div class="my-5 text-center" v-if="merchant_per_category.is_load">
							  <loader />
							</div>
							<template v-else>
							  <div class="my-4" v-if="merchant_per_category.error != ''">
							    <div class="w-100 text-center">
			              <img src="../../../../assets/img/icon/404.png" height="170" class="mb-3">
			              <div class="w-80 mx-auto">
			                <p class="body-1-2 mb-2">"{{keyword}}"</p>
			                <p class="body-2-2 mb-3">{{$t("hotel.concierge.fitur.experience.not-found")}}</p>
			                <button type="button" class="g-btn g-btn-primary-outline g-btn-md" @click="clearSearch()">{{$t("hotel.concierge.fitur.experience.view-all-experience")}}</button>
			              </div>
			            </div>
							  </div>
							  <template v-else>
							  	<div class="row slim-grid-row mb-3">
				        		<div class="col-6 mb-3" v-for="(merchant,index) in merchant_per_category.list">
			              	<ThingsToDoItem :data="merchant" width="100%"></ThingsToDoItem>
				        		</div>
				        	</div>
							  </template>
							</template>
			      </template>
		      </div>
        </div>
      </template>
    </template>
    <!-- NAVBAR -->
    <transition name="fade" v-if="scrollPosition>200">
    	<div class="position-relative z-index-1028">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-top d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white" :class="{'box-shadow-nav':scrollPosition>30}">
                    <div class="container px-4 w-100 py-1">
                    	<div class="row no-gutters py-2 mb-1 w-100">
	                      <div class="col-1">
	                        <router-link :to="'/'+getMerchant.code">
	                          <img src="../../../../assets/img/icon/back.png" class="mt-1 top-2" width="20">
	                        </router-link>
	                      </div>
	                      <div class="col-9">
	                        <div class="">
	                          <transition name="fade">
	                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{data.tagline}}</p>
	                          </transition>
	                        </div>
	                      </div>
	                      <div class="col-2 text-right">
	                        <transition name="fade">
	                          <div class="rounded-100 inline-grid border-semi-grey d-inline-grid" style="padding:6px;" @click="toSearch()">
	                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	                              <mask id="mask0_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="16">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H16.1076V16.1077H1.5V1.5Z" fill="white"/>
	                              </mask>
	                              <g mask="url(#mask0_3948_11251)">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80425 2.625C5.397 2.625 2.625 5.39625 2.625 8.8035C2.625 12.2107 5.397 14.9827 8.80425 14.9827C12.2107 14.9827 14.9827 12.2107 14.9827 8.8035C14.9827 5.39625 12.2107 2.625 8.80425 2.625M8.80425 16.1077C4.77675 16.1077 1.5 12.831 1.5 8.8035C1.5 4.776 4.77675 1.5 8.80425 1.5C12.8318 1.5 16.1077 4.776 16.1077 8.8035C16.1077 12.831 12.8318 16.1077 8.80425 16.1077" fill="#222222"/>
	                              </g>
	                              <mask id="mask1_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="13" width="5" height="5">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9302 13.2803H16.6982V17.0413H12.9302V13.2803Z" fill="white"/>
	                              </mask>
	                              <g mask="url(#mask1_3948_11251)">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1359 17.0413C15.9926 17.0413 15.8486 16.9866 15.7384 16.8771L13.0954 14.2416C12.8756 14.0218 12.8749 13.6656 13.0946 13.4458C13.3136 13.2246 13.6699 13.2261 13.8904 13.4443L16.5334 16.0806C16.7531 16.3003 16.7539 16.6558 16.5341 16.8756C16.4246 16.9866 16.2799 17.0413 16.1359 17.0413" fill="#222222"/>
	                              </g>
	                            </svg>
	                          </div>
	                        </transition>
	                       <!--  <div class="ml-2 language language-custom bg-green" style="top:-6px !important" @click="toggleLanguage(true)">
						                <p class="mb-0 body-2-2 font-extrabold text-white text-uppercase">{{getCurrentLanguage}}</p>
						              </div>
 -->	                      </div>
	                    </div>
				              <flickity ref="flickity" class="flickity-category" :options="slider_option.category">
						            <div class="carousel-cell-category text-center" 
						              v-for="cat in category.list" @click="goToScroll(cat)">
						             <p class="body-3 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer bg-light-page radius-6" :class="{'font-bold delay bg-green text-white border-green':cat.id == category.selected.id}">{{cat.name}}</p>
						            </div>
						          </flickity>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- LANGUAGE -->
    <Language v-if="language" :data="true" @toggleLanguage="toggleLanguage"></Language>
    <!-- POP UP BG -->
    <popUpBG v-if="language"></popUpBG>
    <!-- <bottom-navbar></bottom-navbar> -->

  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {get} from '@/services/index.js';
	import BottomNavbar from '@/components/hotel/BottomNavbar';
  import ThingsToDoItem from '@/components/hotel/concierge/general/ThingsToDoItem'
  import Language from '@/components/hotel/concierge/general/Language'
  import popUpBG from '@/components/hotel/concierge/general/popUpBG'
	import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
  import worldwide from '../../../../assets/img/icon/worldwide.png';

	export default{
		components:{
			BottomNavbar,
			ThingsToDoItem,
			Language,
			popUpBG,
			ClaimingReward
		},
		metaInfo(){
      return {
        title: this.$t("hotel.concierge.fitur.experience.things-to-do"),
        titleTemplate: this.getMetaTitleTemplate
      }
    },
		data(){
			return{
				scrollPosition: null,
				all_cat_img: worldwide,
				is_load: true,
				error: '',
				language: false,
				keyword: '',
				data: {},
				merchant_per_category:{
					list: [],
					is_load: false,
					error: ''
				},
        category:{
        	list: [],
        	selected: {
        		id: 'all',
          	name: 'All Categories',
          	image_url:worldwide
        	}
        },
        merchant_area: '',
        keyword_typing: null,
        slider_option:{
          category:{
            initialIndex: 0,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: true,
            freeScroll: true,
            cellAlign: 'left'
          },
          merchant:{
            initialIndex: 0,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: true,
            freeScroll: true,
            cellAlign: 'left'
          },
        },
			}
		},
		computed:{
			...mapGetters([
				'getMerchant',
				'getCurrentUser',
				'getCurrentLanguage',
				'getMetaTitleTemplate',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied']),
		},
		created(){
      this.$validateActiveReward('concierge-experience')
    },
		mounted(){
			window.addEventListener('scroll', this.updateScroll);
			document.getElementById('top-section').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadFirstData()
      this.loadMerchantArea()
		},
		methods:{
			...mapMutations(['resetConciergeOrder']),
			updateScroll() {
        this.scrollPosition = window.scrollY
      },
			toggleLanguage(data){
        this.language = data
      },
      xScroll(type, id) {
        let content = document.querySelector("#" + id);
        if (type == 'left') {
          content.scrollLeft -= 80;
        } else {
          content.scrollLeft += 80;
        }
      },
      goToScroll(data){
      	document.getElementById('merchant').scrollIntoView({
	        behavior: 'smooth'
	      });
      	this.category.selected = data
      	if(this.category.selected.id != 'all'){
      		this.loadMerchantList()
      	}
      },
      stopLoadData(msg=''){
      	this.is_load = false
      	this.error = msg
      },
      keywordType() {
				if (this.keyword_typing != null) {
					clearTimeout(this.keyword_typing)
				}
				let self = this
				this.merchant_per_category.is_load = true
      	this.merchant_per_category.error = ''
      	this.merchant_per_category.list = []
				this.keyword_typing = setTimeout(() => {
					self.loadMerchantList()
				}, 1000)
			},
			loadMoreData(data){
				let cat = {
					id: data.id,
					name: data.name,
					image_url: data.image_url
				}
				this.goToScroll(cat)
			},



      // API
      loadGeneralData(){
      	return new Promise(done=>{
	        get("CONCIERGE","experience/general",{
	          merchant_id: this.getMerchant.id,
          	membership_reward_id: this.isMembershipRewardApplied ? this.getMembershipRewardApplied.id : ''
	        }).then(response=>{
	          let res = response.data
	          if(res.success){
	            this.data = res.data
	            done(true)
	          }else{
	            done(res.message)
	          }
	        })
      	})
      },
      loadCategoryList(){
      	return new Promise(done=>{
	        get("CONCIERGE","experience/merchant-category-option",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	          let res = response.data
	          if(res.success){
	            this.category.list = res.data
	            this.category.list.unshift({
	            	id: 'all',
	            	name: 'All Categories',
	            	image_url:this.all_cat_img
	            })
	            done(true)
	          }else{
	            done(res.message)
	          }
	        })
      	})
      },
      loadMerchantArea(){
        get("CORE","user-location",{
          lat: this.getMerchant.lat,
          long: this.getMerchant.lng
        }).then(response=>{
					if(response.data.success){
						let location_type = response.data.data.address_components
						this.merchant_area = ''
						for(let i = 0; i < location_type.length;i++){
								if (location_type[i].types[0] == 'administrative_area_level_1') {
									this.merchant_area += location_type[i].short_name+", ";
								}
								if(location_type[i].types[0] == 'country'){
									this.merchant_area += location_type[i].long_name;
								}
						}
					}
        })
      },
      loadFirstData(){
      	this.is_load = true
      	this.error = ''
      	this.loadGeneralData().then(general_response=>{
      		if(general_response == true){
      			this.loadCategoryList().then(category_response=>{
      				if(category_response == true){
      					this.resetConciergeOrder()
      					this.stopLoadData()
		      		}else{
		      			this.stopLoadData(category_response)
		      		}
      			})
      		}else{
      			this.stopLoadData(general_response)
      		}
      	})
      },
      loadMerchantList(){
      	this.merchant_per_category.is_load = true
      	this.merchant_per_category.error = ''
      	this.merchant_per_category.list = []
      	let params = {
					merchant_id: this.getMerchant.id,
					keyword: this.keyword      		
      	}

      	if(this.category.selected.id != 'all'){
      		params.category_id = this.category.selected.id
      	}

      	get("CONCIERGE","experience/merchant",params).then(response=>{
          let res = response.data
          if(res.success != false){
            this.merchant_per_category.list = res.data
            if(res.data.length == 0){
            	this.merchant_per_category.error = 'Data not found.'
            }
          }else{
          	this.merchant_per_category.error = res.message
          }
          this.merchant_per_category.is_load = false
        })
      },
      toSearch(){
      	this.$refs.search.focus()
      },
      clearSearch(){
      	this.keyword = ""
      }
		}
	}
</script>
<style scoped>
.search-custom {
  background-image: url('../../../../assets/img/hotel/search.png');
  height: 48px;
  background-color: #f4f4f4b8 !important;
  background-position: 16px 15px;
  background-size: 15px 15px;
  -o-object-fit: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 7px 30px 7px 44px;
  border:0.5px solid #ddd;
}

.left-0-d{
  left: 0!important
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
.icon-wrapper-circle{
	border-radius: 50%;
	background-color: rgb(233, 255, 227);
	width: 45px;
	height: 45px;
	text-align: center;
}
.cat-wrapper{
	width: 90px;
}
.top-20{
	top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/thingstodo/index.vue